import React from 'react';

// import styled components
import { ModalClose, ModalScreen, ModalWindow } from './styled';

function Modal(props) {
  const { display, overflow, position, height, width, content } = props.attr;

  return (
    <ModalScreen style={{ display, overflow, position }}>
      <ModalWindow height={height} width={width}>
        {content}
      </ModalWindow>
      <ModalClose
        onClick={() => props.toggleModal()}
        onKeyPress={() => props.toggleModal()}
        tabIndex="0"
      >
        ╳
      </ModalClose>
    </ModalScreen>
  );
}

export default Modal;
